export const makeEventId = () => {
  return (
    (+new Date()).toString(36) + "-" + Math.random().toString(36).slice(2, 9)
  );
};
